interface Props {
  /** HTTP response status; null on a transport-level failure. */
  status: number | null;
  success: boolean;
}

// A success/fail pill that also surfaces the HTTP status. Color comes from the
// `success` flag (the backend's authoritative verdict) rather than the raw
// status, so a transport error (status === null) still reads as a failure.
export function StatusPill({ status, success }: Props) {
  const color = success ? 'var(--co-success)' : 'var(--co-error)';
  const label = success ? 'Success' : 'Failed';

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{
        color,
        backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
      }}
    >
      <span>{label}</span>
      <span className="font-mono opacity-80">{status ?? '—'}</span>
    </span>
  );
}
